import { FC } from 'react'

import { useSetAtom } from 'jotai'

import { SequenceMenu } from '@sequencehq/core-components'

import { currentSidebarModeAtom } from 'Automations/automationEditor/atoms'

export const VersionHistoryMenuItem: FC<{
  onClick?: () => void
}> = ({ onClick }) => {
  const setSidebarMode = useSetAtom(currentSidebarModeAtom)

  return (
    <SequenceMenu.Item
      uuid="version-history"
      label="Version history"
      data-testid="automations.editor.kebabMenu.versionHistory"
      onClick={() => {
        setSidebarMode('VERSION_HISTORY')
        onClick?.()
      }}
    />
  )
}
